import styled from "styled-components";
import { PlainTooltip } from "@similarweb/ui-components";
import { SWReactIcons } from "@similarweb/icons";
import { translate } from "app/filters/i18nFilter";

const StyledEmailHeaderCell = styled.div`
    display: flex;
    justify-content: center;
    cursor: pointer;
    & .SWReactIcons {
        height: 18px;
        width: 23px;
    }
`;

export const EmailCellHeader = () => {
    return (
        <PlainTooltip
            placement="top"
            maxWidth={190}
            tooltipContent={translate("si.insightsGenerator.table.headerCells.email.tooltip")}
        >
            <StyledEmailHeaderCell>
                <SWReactIcons
                    iconName="mail"
                    size="sm"
                />
            </StyledEmailHeaderCell>
        </PlainTooltip>
    );
};
